import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import React from 'react';
import { graphql, useFragment } from 'react-relay';

import Loading from 'src/components/Loading';

import TradeRuleListTable from './TradeRuleListTable';

const TradeRuleListTradePointsFragment = graphql`
  fragment TradeRuleListTradePoints_property on Property
  @throwOnFieldError
  @argumentDefinitions(
    first: { type: "Int"}
    after: { type: "String" }
    last: { type: "Int"}
    before: { type: "String" }
  ) {
    uuid
    meters(first:500) {
      edges {
        node {
          uuid
          identifier
          title
          tradePointId
          ...TradeRuleListTable_meter @arguments(
            first: $first
            after: $after
            last: $last
            before: $before
          )
        }
      }
    }
  }
`;

/**
 * TradeRuleListTradePoints functional component displays trade rule tables grouped by meter.
 * @param {object} props - Component props.
 * @param {DateTime} props.date - The date used for the trade rule tables.
 * @param {object} props.property - Property fragment reference.
 * @returns {React.ReactElement} TradeRuleListTradePoints component.
 */
function TradeRuleListTradePoints({ date, property = null }) {
  const propertyData = useFragment(TradeRuleListTradePointsFragment, property);

  if (!propertyData) {
    return <Loading />;
  }

  const { uuid, meters } = propertyData;
  const edges = meters?.edges ?? [];

  return (
    edges.map((meterEdge) => (
      <div key={meterEdge.node.identifier}>
        <h3>
          {meterEdge.node.title}
          <br />
          <small>{meterEdge.node.identifier}</small>
        </h3>
        <TradeRuleListTable meter={meterEdge.node} date={date} propertyId={uuid} />
      </div>
    ))
  );
}

TradeRuleListTradePoints.propTypes = {
  date: PropTypes.instanceOf(DateTime).isRequired,
  property: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default TradeRuleListTradePoints;
